module.exports = __webpack_public_path__ + "static/img/garden-wall-2026.ad383df.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/portfolio/garden-wall-2026.webp
// module id = NG3z
// module chunks = 0